import { cn } from '@/lib/utils'
import type { PageType } from '@/modules/common/consts'
import { useBreadcrumbOverride } from '@/utils'
import { Loader } from '@ur-solutions/react-components'
import { Suspense, type PropsWithChildren, type ReactNode } from 'react'
import { ModuleHeader } from './module-header'

interface ModuleLoaderProps {
  breadcrumbLoading: false | string
}

function ModuleLoader({ breadcrumbLoading }: ModuleLoaderProps) {
  useBreadcrumbOverride(
    !breadcrumbLoading ? null : breadcrumbLoading,
    null,
    true
  )

  return (
    <div className={cn('flex items-center justify-center h-64')}>
      <Loader.Spinner />
    </div>
  )
}

interface ModuleWrapperProps extends PropsWithChildren {
  className?: string

  title: ReactNode
  page?: PageType
  loading?: boolean
  breadcrumbLoading?: false | string

  headerActions?: ReactNode
  headerActionsClassName?: string
  headerRight?: ReactNode
  headerRightClassName?: string
}

export function ModuleWrapper({
  children,
  className,

  title,
  page,
  loading = false,
  breadcrumbLoading = false,

  headerActions,
  headerActionsClassName,
  headerRight,
  headerRightClassName,
}: ModuleWrapperProps) {
  return (
    <Suspense fallback={<ModuleLoader breadcrumbLoading={breadcrumbLoading} />}>
      <div className={cn('p-4', 'md:px-13 md:pt-8 md:pb-13', className)}>
        <ModuleHeader
          title={
            !headerActions ? (
              title
            ) : (
              <div>
                <div>{title}</div>
                <div className={cn('mt-2', headerActionsClassName)}>
                  {headerActions}
                </div>
              </div>
            )
          }
          page={page}
          loading={loading}
          contentClassName={headerRightClassName}
        >
          {headerRight}
        </ModuleHeader>

        {children}
      </div>
    </Suspense>
  )
}
